import {
  BALL_RADIUS,
  CANVAS_SIZE,
  DESKTOP_CANVAS_SIZE,
  STARTING_BALLS,
  RUN,
  STATES
} from './options.js';

import { emitGA } from '../modules/marketing';

import {
  replayButton,
  replayButton2,
  deathFilter,
  stayFilters,
  applyOptions,
  dotsWrapper,
  userInputsWrapper,
  titleDots,
  noteDots,
  replaySection,
  whatsappShare,
  fbShare,
  twitterShare,
  linkedInShare
} from './dom.js';

import { Ball } from './Ball.js';

import { resetValues, updateCount } from './results.js';

let balls = [];
const matchMedia = window.matchMedia('(min-width: 1024px)');

let isDesktop = matchMedia.matches;
let totalStaticPeople = 0;

let isLoaded = false;
let intervalForGA;
applyOptions.addEventListener('click', e => {
  if (!isLoaded) {
    filterChangeAtBegining();
    loadCanvas();
    isLoaded = true;
    dotsWrapper.style.display = 'block';
    titleDots.style.display = 'block';
    noteDots.style.display = 'block';
    userInputsWrapper.style.display = 'none';
    setTimeoutForGa();
  }
});

fbShare.addEventListener('click', (e) => {
  e.preventDefault();
  emitGA &&
    emitGA(
      'Covid Simulator',
      'Result Share Intent',
      'Shared on - FB',
      document.querySelector('.blue #b1').innerText.split(',').join('')
    );
  window.open(e.target.getAttribute('data-href'), 'fb-share','toolbar=0,status=0,width=580,height=325');
})


linkedInShare.addEventListener('click', (e) => {
  e.preventDefault();
  emitGA &&
    emitGA(
      'Covid Simulator',
      'Result Share Intent',
      'Shared on - LinkedIn',
      document.querySelector('.blue #b1').innerText.split(',').join('')
    );
  window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent('https://bit.ly/3447Or5') + '&title=Razorpay - Corona Virus Simulator', '_blank, width=500, height=500, resizable=yes, scrollbars=yes')
})

twitterShare.addEventListener('click', (e) => {
  e.preventDefault();
  emitGA &&
    emitGA(
      'Covid Simulator',
      'Result Share Intent',
      'Shared on - Twitter',
      document.querySelector('.blue #b1').innerText.split(',').join('')
    );
  window.open(e.target.getAttribute('data-href'),'twitter-share','toolbar=0,status=0,width=580,height=325');
})

whatsappShare.addEventListener('click', () => {
  emitGA &&
    emitGA(
      'Covid Simulator',
      'Result Share Intent',
      'Shared on - Whatsapp',
      document.querySelector('.blue #b1').innerText.split(',').join('')
    );
})

function setWhatsapp(liveCount)  {
  let text = `By social distancing, I’ll continue saving ${liveCount} people from getting infected by COVID-19. You should also do your bit.%20%23DistancingSavesLives https://razorpay.com/corona-virus-simulator/`;
  whatsappShare.setAttribute('href',"whatsapp://send?text=" + text);
}

function setTimeoutForGa() {
  intervalForGA = setInterval(function() {
    if (
      replaySection.style.display === 'flex' ||
      replaySection.style.display === 'block'
    ) {
      intervalForGA && clearInterval(intervalForGA);
      let dateComp = document.getElementById('current-date').innerText;
      let blueResultContainer = document.querySelector(
        '.blue.result-container'
      );
      let redResult = Number(document.querySelector('.red #r1').innerText);
      let blueResult = Number(document.querySelector('.blue #b1').innerText);
      let blueResultContinue = parseInt(document.querySelector('.blue #b2').innerText.split(',').join(''), 10);
      let text = '';
      if (blueResultContainer.style.display === 'none') {
        text += 'risked,';
        text += blueResult;
      } else {
        text += 'saved,';
        text += redResult;
      }
      emitGA &&
        emitGA(
          'Covid Simulator',
          'Result Displayed',
          dateComp + ',' + text
        );
      //
      titleDots.style.display = 'none';
      noteDots.style.display = 'none';
      //
      let setW = blueResultContinue > blueResult ? blueResultContinue : blueResult;
      setWhatsapp(setW);
    }
  }, 500);
}

const filterChangeAtBegining = e => {
  let isChecked = false;
  totalStaticPeople = 0;
  Array.prototype.forEach.call(stayFilters, function(filter) {
    if (filter.checked) {
      totalStaticPeople += Number(filter.getAttribute('data-static'));
      isChecked = true;
    }
  });
  totalStaticPeople = 100 - totalStaticPeople;
  totalStaticPeople = totalStaticPeople <= 0 ? 0 : totalStaticPeople;
  totalStaticPeople = totalStaticPeople >= 100 ? 100 : totalStaticPeople;
  RUN.filters.stayHome = isChecked;
  // console.log('Total static:', 100 - totalStaticPeople);
};

let loadCanvas = () => {
  const canvas = new window.p5(sketch => {
    // eslint-disable-line
    const startBalls = () => {
      let id = 0;
      balls = [];
      Object.keys(STARTING_BALLS).forEach(state => {
        for (let i = 0; i < Number(STARTING_BALLS[state]); i++) {
          const hasMovement = RUN.filters.stayHome
            ? sketch.random(0, 100) < totalStaticPeople ||
              state === STATES.infected
            : true;

          balls[id] = new Ball({
            id,
            sketch,
            state,
            hasMovement,
            x: sketch.random(BALL_RADIUS, sketch.width - BALL_RADIUS),
            y: sketch.random(BALL_RADIUS, sketch.height - BALL_RADIUS)
          });
          id++;
        }
      });
    };

    const createCanvas = () => {
      const { height, width } = isDesktop ? DESKTOP_CANVAS_SIZE : CANVAS_SIZE;

      sketch.createCanvas(width, height);
    };

    sketch.setup = () => {
      createCanvas();
      startBalls();

      matchMedia.addListener(e => {
        isDesktop = e.matches;
        createCanvas();
        startBalls();
        resetValues();
      });

      replayButton.addEventListener('click', () => {
        userInputsWrapper.style.display = 'flex';
        dotsWrapper.style.display = 'none';
        titleDots.style.display = 'none';
        noteDots.style.display = 'none';
      });

      replayButton2.addEventListener('click', () => {
        userInputsWrapper.style.display = 'flex';
        dotsWrapper.style.display = 'none';
        titleDots.style.display = 'none';
        noteDots.style.display = 'none';
      });

      deathFilter.onclick = () => {
        RUN.filters.death = !RUN.filters.death;
        document
          .getElementById('death-count')
          .classList.toggle('show', RUN.filters.death);
        startBalls();
        resetValues();
      };

      applyOptions.addEventListener('click', filterChangeResponse);
    };

    const filterChangeResponse = e => {
      let isChecked = false;
      totalStaticPeople = 0;
      Array.prototype.forEach.call(stayFilters, function(filter) {
        if (filter.checked) {
          totalStaticPeople += Number(filter.getAttribute('data-static'));
          isChecked = true;
        }
      });
      totalStaticPeople = 100 - totalStaticPeople;
      totalStaticPeople = totalStaticPeople <= 0 ? 0 : totalStaticPeople;
      totalStaticPeople = totalStaticPeople >= 100 ? 100 : totalStaticPeople;
      RUN.filters.stayHome = isChecked;
      dotsWrapper.style.display = 'block';
      titleDots.style.display = 'block';
      noteDots.style.display = 'block';
      userInputsWrapper.style.display = 'none';
      startBalls();
      resetValues();
      // console.log('Total static:', 100 - totalStaticPeople);
      setTimeoutForGa();
    };

    sketch.draw = () => {
      sketch.background('#01112D');
      balls.forEach(ball => {
        ball.checkState();
        ball.checkCollisions({ others: balls });
        ball.move();
        ball.render();
      });
      updateCount();
    };
  }, document.getElementById('canvas'));
};
